import type { EntityReadStorage } from 'serviceWorker/channelServers/entitySource';
import * as dbDirectoriesService from 'serviceWorker/db/directories/directoriesService';
import * as dbDocumentationsService from 'serviceWorker/db/documentations/documentationsService';
import { directoriesSync } from 'serviceWorker/services/directories';
import { documentationsSync } from 'serviceWorker/services/documentations';
import { companySource } from 'serviceWorker/services/companies/companySource';
import { contractSource } from 'serviceWorker/services/contracts/contractSource';
import { inspectionTemplateStorage } from 'serviceWorker/services/inspectionTemplates/inspectionTemplateSource';
import { inspectionStorage } from 'serviceWorker/services/inspections/inspectionSource';
import { issueFormSource } from 'serviceWorker/services/issueForm/issueFormSource';
import { issueStorage } from 'serviceWorker/services/issues/issueSource';
import { levelSource } from 'serviceWorker/services/levels/levelSource';
import { siteSource } from 'serviceWorker/services/sites/siteSource';
import { userSource } from 'serviceWorker/services/users/userSource';
import { visibleFieldSource } from 'serviceWorker/services/visibleFields/visibleFieldSource';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { ProjectDataKey } from 'shared/domain/projectData/projectDataModel';
import { documentationContract } from 'shared/domain/documentation/documentationContract';
import { directoryContract } from 'shared/domain/directory/directoryContract';

/** Where each kind of project data lives in the worker and how it is downloaded. */
export const projectDataSources: Readonly<Record<ProjectDataKey, EntityReadStorage>> = {
  [ProjectDataKey.issues]: issueStorage,
  [ProjectDataKey.templates]: inspectionTemplateStorage,
  [ProjectDataKey.inspections]: inspectionStorage,
  [ProjectDataKey.companies]: companySource.storage,
  [ProjectDataKey.contracts]: contractSource.storage,
  [ProjectDataKey.users]: userSource.storage,
  [ProjectDataKey.sites]: siteSource.storage,
  [ProjectDataKey.levels]: levelSource.storage,
  [ProjectDataKey.issueForms]: issueFormSource.storage,
  [ProjectDataKey.visibleFields]: visibleFieldSource.storage,
  // Documentations and directories are read through their own queries, not an entity source.
  [ProjectDataKey.documentations]: {
    service: dbDocumentationsService,
    contract: { key: documentationContract.key, collectionEvent: DomainMessagesTypes.allDocumentations },
    sync: documentationsSync.sync,
  },
  [ProjectDataKey.directories]: {
    service: dbDirectoriesService,
    contract: { key: directoryContract.key, collectionEvent: DomainMessagesTypes.allDirectories },
    sync: directoriesSync.sync,
  },
};
